import { makeStyles } from '@material-ui/core';
import { CheckCircleOutlineRounded as CheckCircleOutlineRoundedIcon } from '@material-ui/icons';
import { Colors } from '@rentguru/commons-utils';
import { useState } from 'react';
import { IntlFormatters } from 'react-intl';

import { CopyIcon } from '../../icons';
import { CustomIconButton } from '../buttons';

interface CopyActionProps {
  text: unknown;
  formatMessage: IntlFormatters['formatMessage'];
}

const useStyles = makeStyles({
  iconButton: {
    '&:hover': {
      backgroundColor: 'transparent',
    },
  },
});

export const CopyAction = ({ text, formatMessage }: CopyActionProps) => {
  const classes = useStyles();
  const [isSuccess, setIsSuccess] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(String(text));
      setIsSuccess(true);
      setTimeout(() => {
        setIsSuccess(false);
      }, 1000);
    } catch (error) {
      console.error('Failed to copy text:', error);
    }
  };

  const icon = isSuccess ? CheckCircleOutlineRoundedIcon : CopyIcon;
  const iconStyle = isSuccess
    ? { height: 16, width: 16, fill: Colors.MALACHITE_GREEN }
    : { height: 16, width: 16, fill: Colors.BLUE_GREY };

  return (
    <CustomIconButton
      className={classes.iconButton}
      onClick={handleCopy}
      Icon={icon}
      iconStyle={iconStyle}
      tooltipText={formatMessage({ id: isSuccess ? 'copied' : 'copy' })}
      style={{ padding: 5 }}
    />
  );
};
